import { Proxies } from '@ui-system/interfaces';
import * as ComponentProxies from '@ui-system/proxy';

const UI: Proxies = ComponentProxies;

export default UI;
